import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";

const HeroSection = ({ service, providerListStorageKey, data }) => {
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const navigate = useNavigate();
    const {
        HERO_TITLE_LINE_1,
        HERO_TITLE_LINE_2,
        HERO_TITLE_LINE_3,
        HERO_SUBTITLE,
        HERO_DESCRIPTION,
        SIGN_UP_BUTTON_TEXT,
        CATERING_BUTTON_TEXT,
        CONFIRM_DIALOG_HEADER,
        CONFIRM_DIALOG_MESSAGE,
    } = data;

    const openAlertDialog = (serviceEventDetails) => {
        confirmDialog({
            message: CONFIRM_DIALOG_MESSAGE,
            header: CONFIRM_DIALOG_HEADER,
            defaultFocus: "accept",
            className: "th-auth__dialog",
            accept: () => {
                localStorage.setItem(
                    providerListStorageKey,
                    JSON.stringify(serviceEventDetails)
                );
                navigate("/login");
            },
        });
    };

    const navigateToProvider = () => {
        const serviceEventDetails = {
            serviceDetails: service,
            eventDetails: {},
        };

        if (isLoggedIn) {
            service.id === 2
                ? navigate("/dashboard", { state: serviceEventDetails })
                : navigate("/providers", { state: serviceEventDetails });
            window.scrollTo({ top: 0 });
        } else {
            openAlertDialog(serviceEventDetails);
        }
    };

    return (
        <div >
            <div className="th-service__container">
                <div className="th-hero__text th-service__font__size">
                    <span className="th-hero__text__title">
                        {HERO_TITLE_LINE_1}
                        <br /> {HERO_TITLE_LINE_2}
                    </span>
                    <span className="th-hero__text__subtitle">
                        {" "}
                        {HERO_SUBTITLE}
                    </span>
                    <br />
                    <span className="th-hero__text__title">
                        {HERO_TITLE_LINE_3}
                    </span>
                </div>
                <span style={{ color: "#646464" }}>{HERO_DESCRIPTION}</span>
                <div className="th-service__buttons">
                    {!isLoggedIn && (
                        <Button
                            variant="contained"
                            className="th-nav__provider__txt"
                            sx={{
                                display: "flex",
                                textTransform: "initial",
                                height: "48px",
                                padding: "12px 24px",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px",
                                alignSelf: "stretch",
                                borderRadius: "8px",
                                background: "#383838",
                                width: "100%",
                            }}
                            onClick={() => navigate("/signup")}
                        >
                            {SIGN_UP_BUTTON_TEXT}
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        className="th-nav__provider__txt"
                        sx={{
                            display: "flex",
                            textTransform: "initial",
                            height: "48px",
                            padding: "12px 24px",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "10px",
                            alignSelf: "stretch",
                            borderRadius: "8px",
                            color: "#383838",
                            border: "1px solid #383838",
                            background: "transparent",
                            width: "100%",
                        }}
                        onClick={navigateToProvider}
                    >
                        {CATERING_BUTTON_TEXT}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;
